<template>
  <div>
    <a-modal v-model="visible" :title="getTitle" :width="1300" style="height: 900px" centered :mask-closable="false" :footer="false" @cancel="closed">
      <plan-case-list :plan-id="planId" :result-disabled="false" />
    </a-modal>
  </div>
</template>

<script>
import PlanCaseList from '@/pages/project/testplan/components/PlanCaseList';

export default {
  name: 'PlanExecuteModal',
  components: { PlanCaseList },
  data() {
    return {
      visible: false,
      planId: null
    };
  },
  computed: {
    getTitle() {
      return '执行测试计划';
    }
  },
  methods: {
    onOpen(planId) {
      this.visible = true;
      this.planId = planId;
    },
    closed() {
      this.utils.trackClick({ name: '关闭执行测试计划' });
      this.visible = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-modal-body {
  padding: 12px;
}
</style>
